import { useState } from 'react'
import { useLogin } from "../../hooks/useLogin"

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { error, login } = useLogin()

  const handleSubmit = (e) => {
    e.preventDefault()
    login(email, password)
  }
  
  return (
    <div className="">
         {/* <div className="form">   */}
      <h2>Login</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <p>email:</p>
          <input
            required
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </label>
        <label>
          <span>password:</span>
          <input
            required
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </label>
        <button className='btn'>log in</button>
        {error && <p>{error}</p>}
      </form>
    </div>
  )
}
